import { useEffect, useState } from 'react';
import { callableErrorMessage, confirmEmailToken } from '../services/api';

type Props = {
  token: string;
  onDone: () => void;
};

export default function VerifyEmailPage({ token, onDone }: Props) {
  const [status, setStatus] = useState<'working' | 'ok' | 'error'>('working');
  const [message, setMessage] = useState('Confirmando e-mail…');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await confirmEmailToken(token);
        if (cancelled) return;
        setStatus('ok');
        setMessage(
          res.recoveryEmail
            ? `E-mail ${res.recoveryEmail} verificado. Você pode voltar ao checkout.`
            : 'E-mail verificado. Você pode voltar ao checkout.',
        );
      } catch (e) {
        if (cancelled) return;
        setStatus('error');
        setMessage(callableErrorMessage(e));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="my-shell gap-5 text-center">
      <h1 className="text-2xl font-bold text-foreground">Verificação de e-mail</h1>
      <p className={status === 'error' ? 'text-sm text-red-600' : 'text-sm text-muted-foreground'}>
        {message}
      </p>
      <button type="button" className="my-btn-primary" onClick={onDone}>
        {status === 'ok' ? 'Continuar' : 'Voltar'}
      </button>
    </div>
  );
}
